<button tabindex="-1" mat-icon-button class="close-button" type="button" [mat-dialog-close]="true">
  <mat-icon mat-icon color="warn">close</mat-icon>
</button>

<div class="toggle-bar">
  <h2 class="dialog-header">Inland Charges</h2>
  <mat-button-toggle-group [(ngModel)]="selectedWarehouseID" (change)="applyWarehouseFilter()" appearance="standard">
    <mat-button-toggle [value]="'ALL'"
                       [class.strong]="selectedWarehouseID == 'ALL'"
    >
      All
    </mat-button-toggle>
    <mat-button-toggle
      *ngFor="let wh of warehouses"
      [value]="wh.id"
      [class.strong]="selectedWarehouseID == wh.id"
      [ngClass]="{
        'strong': selectedWarehouseID == wh.id,
        'lincolnshire': wh.id == 1,
        'summerville': wh.id == 2,
        'northcharleston': wh.id == 5,
        'matraville': wh.id == 4,
        'direct/virtual': wh.id == 0
      }"
    >{{ wh.name }}</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="scroll-table-container">
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Supplier </th>
      <td mat-cell *matCellDef="let row"> {{ row.companyName }} </td>
    </ng-container>

    <ng-container matColumnDef="goodsCost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Goods </th>
      <td mat-cell *matCellDef="let row"> {{ row.goodsCost }} {{ row.symbol }} </td>
    </ng-container>

    <ng-container matColumnDef="freightCost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Freight </th>
      <td mat-cell *matCellDef="let row"> {{ row.freightCost }} {{ row.symbol }} </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Qty </th>
      <td mat-cell *matCellDef="let row"> {{ row.quantity }} </td>
    </ng-container>

    <ng-container matColumnDef="weight">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Weight </th>
      <td mat-cell *matCellDef="let row"> {{ row.weight | number:'1.2-2' }} kg </td>
    </ng-container>

    <ng-container matColumnDef="volume">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Volume </th>
      <td mat-cell *matCellDef="let row"> {{ row.volume | number:'1.3-3' }} m³ </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['companyName', 'goodsCost', 'freightCost', 'quantity', 'weight', 'volume']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['companyName', 'goodsCost', 'freightCost', 'quantity', 'weight', 'volume'];"></tr>

  </table>

</div>
